import { Box, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { emit } from "react-native-react-bridge/lib/web";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import {
  createSession,
  getActiveSession,
  getManagers,
  validateManagerPin,
} from "../../../../../../config/Services";
import { setInLocalStorage } from "../../../../../../utils/localStorageHelpers";
import {
  addLicense,
  addadvance,
  addmanagerpin,
  addmanageruidx,
  addpin,
} from "../../../all-products/redux/Actions/SessionActions";
import { getMobilePos } from "../../../all-products/redux/Reducers/paginationReducer";
import {
  getAmount,
  getLicense,
  getmangerPin,
  getmangeruidx,
  getsessionPin,
} from "../../../all-products/redux/Reducers/sessionReducer";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import "./index.css";
import SessionPageLeft from "../../../sessionPageV2/SessionPageLeft";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import PosCustomDropdown from "../../../../../../customComponents/PosCustomDropdown/PosCustomDropdown";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

export const ManagerAuthV2 = () => {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedLicense = useSelector(getLicense);
  const amount = useSelector(getAmount);
  const pin = useSelector(getsessionPin);
  const managerPin = useSelector(getmangerPin);
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const orgId = localStorage.getItem("orgId");
  const contextId = localStorage.getItem("locId");
  const uidx = retailUserDetails?.uidx;
  const [loader, setLoader] = useState(false);
  const managerNumber = useSelector(getmangeruidx);
  const mangerPin = useSelector(getmangerPin);
  const isMobilePos = useSelector(getMobilePos);
  const [isVisible, setVisible] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);
  const [progressBarFull, setProgressBarFull] = useState(false);
  const userName = retailUserDetails?.firstName + " " + retailUserDetails?.secondName;

  const toggle = () => {
    setVisible(!isVisible);
  };
  const { pathname } = useLocation();
  const daySessionId = localStorage.getItem("daySessionId");
  const isMobile = useGetDevice();

  // Disable start session if manager pin is not entered
  const handleStartSessionDisable = () => {
    if (!managerPin) {
      showSnackbar("Enter manager pin to proceed", "error");
    }
  };

  const sessionUidx = retailUserDetails?.uidx;
  const sessionlocId = localStorage.getItem("locId");

  /**
   * Handles session start as manager.
   * Validates manager pin, creates session, updates Redux/localStorage, and navigates.
   */
  const handleStartSession = () => {
    setLoader(true);
    let managerpayload = {
      mobile: managerNumber,
      primaryPassword: mangerPin,
    };
    validateManagerPin(managerpayload)
      .then((res) => {
        showSnackbar("Success pin verified", "success");
        setLoader(false);
        let payload = {
          uidx: uidx,
          role: "CASHIER",
          organizationId: orgId,
          locationId: contextId,
          licenseName: selectedLicense?.licenseName,
          licenseId: selectedLicense?.licenseId,
          cashDrawerStartingAmount: amount === "" ? "0" : amount,
          createdBy: "manager",
          createdByName: userName,
          posType: isMobile ? "MPOS" : "POS",
        };
        createSession(payload)
          .then((res) => {
            if (res?.data?.es === 1) {
              // Error: reset Redux and local state, navigate to start day
              showSnackbar(res?.data?.message, "error");
              setLoader(false);
              dispatch(
                addLicense({
                  licenseId: "",
                  licenseName: "",
                })
              );
              dispatch(addadvance(""));
              dispatch(addpin(""));
              dispatch(addmanagerpin(""));
              dispatch(addmanageruidx(""));
              setTimeout(() => {
                navigate("/session-page/start-day");
              }, 2000);
            } else {
              // Success: update localStorage and navigate to session listing
              showSnackbar(res?.data?.message, "success");
              setLoader(false);
              getActiveSession(sessionUidx, sessionlocId, daySessionId).then((res) => {
                if (res?.data?.statusCode === 300) {
                } else {
                  if (res?.data?.hasOwnProperty("machines")) {
                    localStorage.setItem("machineId", res?.data?.machines?.[0].machineId || 0);
                    if (
                      localStorage.getItem("loggedInCount") === null ||
                      localStorage.getItem("loggedInCount") === undefined
                    ) {
                      localStorage.setItem("storeMode", "ONLINE");
                      localStorage.setItem("cartStoreMode", "ONLINE");
                      localStorage.setItem("loggedInCount", 1);
                    }
                  }
                  localStorage.setItem("sessionId", res?.data?.userSession?.sessionId);
                  localStorage.setItem("licenseId", res?.data?.userSession?.licenseId);
                  setInLocalStorage("licenseName", res?.data?.userSession?.licenseName);
                  isMobilePos &&
                    emit({
                      type: "localData",
                      data: {
                        sessionId: res?.data?.userSession?.sessionId,
                        licenseId: res?.data?.userSession?.licenseId,
                        licenseName: res?.data?.userSession?.licenseName,
                      },
                    });
                }
              });
              setTimeout(() => {
                navigate("/session-page/session-listing");
              }, 1000);
            }
          })
          .catch((err) => {
            showSnackbar(err?.response?.data?.message || err?.message, "error");
            setLoader(false);
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      });
  };

  //to validate managers pin

  const [managerDetails, setManagerDetails] = useState([{}]);

  /**
   * Fetches manager details for dropdown selection on mount.
   */
  useEffect(() => {
    const payload = { contextId };
    getManagers(payload).then((res) => {
      const response = res?.data?.data?.map((e) => {
        return {
          value: e?.mobile_number,
          label: e?.first_name,
        };
      });
      setManagerDetails(response);
    });
  }, []);

  /**
   * Handles cancel button click.
   * Navigates to previous session page or opening page based on route.
   */
  const handleCancel = () => {
    if (pathname == "/session-page/closing") {
      navigate("/session-page/session-listing");
    } else {
      navigate("/session-page/opening");
    }
  };

  /**
   * Handles form submit for manager authentication.
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    handleStartSession();
  };

  // Progress bar values for session setup steps
  const progressValue = selectedManager ? (progressBarFull ? 100 : 50) : 0;
  const progressColor = selectedManager
    ? progressBarFull
      ? "var(--blue-b0)"
      : "var(--blue-b2)"
    : "";

  return (
    <Navbar>
      <Box sx={{ width: "100%" }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <SessionPageLeft />
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="newSessionRightContainer">
                <div className="newManagerAuthContainer">
                  <div className="newSessionRightInnerContainer">
                    <p className="startText">Start Session</p>
                    <div className="progressContainer">
                      <progress
                        value={100}
                        max={100}
                        style={{ "--progress-color": "var(--blue-b0)" }}
                      />
                      <progress
                        value={100}
                        max={100}
                        style={{ "--progress-color": "var(--blue-b0)" }}
                      />
                      <progress
                        value={100}
                        max={100}
                        style={{ "--progress-color": "var(--blue-b0)" }}
                      />
                      <progress
                        value={progressValue}
                        max={100}
                        style={{ "--progress-color": progressColor }}
                      />
                    </div>
                    <p className="sessionPageLabelText">Select Manager</p>
                    <PosCustomDropdown
                      placeholder={!isMobile ? "Use arrow key to select manager" : "Select"}
                      width={"100%"}
                      border={"0.5px solid var(--surface-g2)"}
                      radius={"4px"}
                      fontSize={"1rem"}
                      isParentLeftIcon={false}
                      dropdownData={managerDetails}
                      selectedData={selectedManager}
                      setSelectedData={(data) => {
                        setSelectedManager(data);
                        dispatch(addmanageruidx(data.parentValue));
                      }}
                      keyboard={true}
                      enableScrollEffect={false}
                    />
                    <p className="sessionPageLabelText">Pin</p>
                    <div className="sessionPageInputWrapper">
                      <input
                        type={isVisible ? "number" : "password"}
                        inputMode="numeric"
                        onChange={(e) => {
                          e.target.value.length > 0
                            ? setProgressBarFull(true)
                            : setProgressBarFull(false);
                          dispatch(addmanagerpin(e.target.value));
                        }}
                        placeholder="Enter Pin"
                        className="sessionPageInput"
                      />
                      <span className="sessionPageInputToggleButton" onClick={toggle}>
                        {isVisible ? (
                          <PosCustomIcon icon={<EyeSlashIcon />} height={"16px"} width={"16px"} />
                        ) : (
                          <PosCustomIcon icon={<EyeIcon />} height={"16px"} width={"16px"} />
                        )}
                      </span>
                    </div>
                    <div className="sessionPageButtonContainer">
                      <PosCustomButton
                        title="Cancel"
                        variant="black-s"
                        type="button"
                        onClickFunction={handleCancel}
                        radius="8px"
                        width="100%"
                        p={"12px 16px"}
                      />
                      <PosCustomButton
                        title="Finish"
                        variant="blue-d"
                        type="submit"
                        onClickFunction={handleStartSessionDisable}
                        loading={loader}
                        disabled={!mangerPin || !managerNumber}
                        radius="8px"
                        width="100%"
                        p={"12px 16px"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Navbar>
  );
};
